import { render, staticRenderFns } from "./CryptoTest.vue?vue&type=template&id=1f6f82f4"
import script from "./CryptoTest.vue?vue&type=script&lang=js"
export * from "./CryptoTest.vue?vue&type=script&lang=js"
import style0 from "./CryptoTest.vue?vue&type=style&index=0&id=1f6f82f4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports